import * as layout from './actions';
import { createSelector, createFeatureSelector, combineReducers } from '@ngrx/store';
import { Document } from '../../models/document';
import { StructureSite } from '../../models/structuresite';
import { User } from '../../models/user';
import { Societe, Signataire } from '../../models/societe';

const GAMME_CLE_EN_MAIN = 'cle_en_main';

export interface IState{
    user?: User;
    document?: Document;
    societe?: Societe;
    signataire?: Signataire;
    allinfosdoc?: any;
    listdocuments?: any;
    structuresite?: any;
}

const INITIAL_STATE: IState = {
    structuresite: {}
}

export function reducer(state = INITIAL_STATE, action: layout.layoutAction): IState{
    switch(action.type){

        case layout.CHOOSE_DOC:
            return {... state, document: action.payload};

        case layout.ADD_SOCIETE:
            return {... state, societe: action.payload};

        case layout.ADD_SIGNATAIRE:
            return {... state, signataire: action.payload};

        case layout.ADD_DOCUMENT:
            return {... state, document: action.payload};
        
        case layout.LIST_DOCUMENTS:
            return {... state, listdocuments: action.payload};

        case layout.STRUCTURE_SITE:
            return {... state, structuresite: action.payload};

        case layout.GAMME_SITE:
            if (state.structuresite.gamme == action.payload){
                return state;
            }
            let statestruct = {... state, 
                structuresite: 
                    {...state.structuresite, 
                        gamme : action.payload, 
                        model: ''
                    }
            };
            if (action.payload == GAMME_CLE_EN_MAIN){
                statestruct.structuresite.listing = 1;
                statestruct.structuresite.detail = 1;
            }           
            return statestruct;

        case layout.MODEL_SITE:
            if (state.structuresite.model == action.payload){
                return state;
            }
            return {... state, 
                structuresite: {...state.structuresite, model : action.payload }
            };

        case layout.LISTING_SITE:
            if (state.structuresite.listing == action.payload){
                return state;
            }
            return {... state, 
                structuresite: {...state.structuresite, listing : action.payload }
            };

        case layout.DETAIL_SITE:
            if (state.structuresite.detail == action.payload){
                return state;
            }
            return {... state, 
                structuresite: {...state.structuresite, detail : action.payload }
            };

        case layout.INITIALIZE: 
            return INITIAL_STATE;

        default:
            return state;
            
    }
}






// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/common/appstore/reducers.ts